"use client";

import { NextIntlClientProvider } from "next-intl";
import { QueryProvider } from "@/providers/QueryProvider";
import CookieConsentProvider from "@/providers/CookieConsentProvider";
import { RuntimeConfigProvider } from "@/providers/RuntimeConfigProvider";
import { Toaster } from "sonner";
import RouteChangeHandler from "@/hook/RouteChangeHandler";
import ClientEnhancements from "@/Layout/ClientEnhancements";
import ServerAppShell from "@/Layout/ServerAppShell";

export default function ClientProviders({ locale, messages, children }) {
  return (
    <>
      <RouteChangeHandler />
      <RuntimeConfigProvider>
        <QueryProvider>
          <CookieConsentProvider>
            <NextIntlClientProvider locale={locale} messages={messages} timeZone="Europe/Stockholm">
              <ServerAppShell>{children}</ServerAppShell>
              <ClientEnhancements />
              <Toaster position="top-right" richColors />
            </NextIntlClientProvider>
          </CookieConsentProvider>
        </QueryProvider>
      </RuntimeConfigProvider>
    </>
  );
}
